var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{style:({backgroundColor:_vm.bgColor}),attrs:{"image-asset":""}},[(_vm.url)?_c('img',{style:({ objectFit: _vm.fit }),attrs:{"src":_vm.source,"alt":_vm.alt}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }